/** EOD download + import phase definitions (mirrors pages/eod_sync.php & eod_import.php) */

export const ENGINE = '/engine/';

export const SYNC_FILE_TYPES = [
  { phase: 1, section: 'Phase 1 — Equities & Spot', sectionHint: 'Target: 4:30 PM IST (retries → 8:00 PM) · eod-oc / eod-chart', sectionStyle: { background: 'rgba(16,185,129,.12)', color: '#4ade80' }, items: [
    { value: 'eq_bhav', label: 'EQ BhavCopy', meta: 'eq_bhav/', group: 'file', defaultChecked: true },
    { value: 'fo_bhav', label: 'FO BhavCopy NSE', meta: 'fo_bhav/', group: 'file', defaultChecked: true },
    { value: 'fo_bhav_bse', label: 'FO BhavCopy BSE', meta: 'fo_bhav_bse/', group: 'file', defaultChecked: true },
    { value: 'idx_spot', label: 'Index Spot NSE', meta: 'idx_spot/', group: 'file', defaultChecked: true },
    { value: 'idx_spot_bse', label: 'Index Spot BSE', meta: 'idx_spot_bse/', group: 'file', defaultChecked: true },
  ]},
  { phase: 2, section: 'Phase 2 — Derived & Web', sectionHint: 'Target: 4:45–5:00 PM IST', sectionStyle: { background: 'rgba(99,102,241,.12)', color: '#818cf8' }, items: [
    { value: 'volt_data', label: 'FO Volatility', meta: 'volt_data/', group: 'file', defaultChecked: true },
    { value: 'fii_dii_cash', label: 'FII/DII Cash', meta: 'Moneycontrol', group: 'api', badge: 'api', defaultChecked: true },
  ]},
  { phase: 3, section: 'Phase 3 — Participant & FII', sectionHint: 'Target: 6:30 PM, retries → 8:00 PM IST', sectionStyle: { background: 'rgba(245,158,11,.12)', color: '#fbbf24' }, items: [
    { value: 'participant_oi', label: 'Participant OI', meta: 'participant_oi/', group: 'file', defaultChecked: true },
    { value: 'participant_vol', label: 'Participant VOL', meta: 'participant_vol/', group: 'file', defaultChecked: true },
    { value: 'fii_stats', label: 'FII Stats (XLS)', meta: 'fii_stats/', group: 'file', defaultChecked: true },
  ]},
];

export const IMPORT_FILE_TYPES = [
  { phase: 1, section: 'Phase 1 — Equities & Spot', sectionHint: 'after Phase 1 DL (retries until critical files land)', sectionStyle: { background: 'rgba(16,185,129,.12)', color: '#4ade80' }, items: [
    { value: 'eq_bhav', label: 'EQ BhavCopy', meta: '→ eq_data', defaultChecked: true },
    { value: 'fo_bhav', label: 'FO BhavCopy (NSE + BSE)', meta: '→ fno_data', defaultChecked: true },
    { value: 'idx_spot', label: 'Index Spot NSE', meta: '→ eod_idx_spot', defaultChecked: true },
    { value: 'idx_spot_bse', label: 'Index Spot BSE', meta: '→ eod_idx_spot', defaultChecked: true },
  ]},
  { phase: 2, section: 'Phase 2 — Derived & Web', sectionHint: 'after ~16:45 DL', sectionStyle: { background: 'rgba(99,102,241,.12)', color: '#818cf8' }, items: [
    { value: 'volt_data', label: 'FO Volatility', meta: '→ eod_volatility', defaultChecked: true },
  ]},
  { phase: 3, section: 'Phase 3 — Participant & FII', sectionHint: 'after ~18:30 DL', sectionStyle: { background: 'rgba(245,158,11,.12)', color: '#fbbf24' }, items: [
    { value: 'fii_stats', label: 'FII Stats (XLS)', meta: '→ eod_fii_mf', defaultChecked: true },
    { value: 'participant_oi', label: 'Participant OI', meta: '→ nse_participant_raw', defaultChecked: false },
    { value: 'participant_vol', label: 'Participant VOL', meta: '→ nse_participant_raw', defaultChecked: false },
  ]},
];

export function todayIso() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function defaultCheckedKeys(sections) {
  const keys = [];
  sections.forEach((sec) => sec.items.forEach((it) => { if (it.defaultChecked) keys.push(it.value); }));
  return keys;
}

export function keysForPhase(sections, phaseNum) {
  const keys = [];
  const sec = sections.find((s) => s.phase === phaseNum);
  if (sec) sec.items.forEach((it) => keys.push(it.value));
  return keys;
}